<script setup lang="ts">
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useQuizterStore } from '../../stores/quizterStore';
import LeaderBoard from '../../components/host/LeaderBoard.vue';
import Card from '../../components/Card.vue';
import NextButton from '../../components/NextButton.vue';
import useLocale from '../../../composables/use-locale';
import FinalQuestionAnimation from '../../components/host/FinalQuestionAnimation.vue';

const quizterStore = useQuizterStore();
const {
  results,
  currentQuestionAnswer,
  currentQuestion,
  currentQuestionIndex,
  numberOfQuestions,
  isLoading,
  gameOptions,
} = storeToRefs(quizterStore);

const { t } = useLocale();

const isNextQuestionFinal = computed(
  () => !!numberOfQuestions.value && currentQuestionIndex.value === numberOfQuestions.value - 2,
);

const showFinalQuestionAnimation = ref(false);

const handleNextQuestion = () => {
  if (isNextQuestionFinal.value) {
    showFinalQuestionAnimation.value = true;
  } else {
    goToNextQuestion();
  }
};

const goToNextQuestion = () => {
  if (gameOptions.value.useQuestionShowTimer) {
    quizterStore.nextQuestion();
  } else {
    quizterStore.showQuestionPhrase();
  }
};
</script>

<template>
  <div class="d-flex flex-column align-center ga-6">
    <!-- Animation takes over the whole area (no card, no buttons) -->
    <FinalQuestionAnimation v-if="showFinalQuestionAnimation" @complete="goToNextQuestion" />

    <!-- Normal content: Card + buttons (hidden during animation) -->
    <template v-else>
      <Card :content-max-width="800">
        <LeaderBoard
          :key="`results-${results.length}`"
          :results="results"
          :currentCorrectAnswer="currentQuestionAnswer || undefined"
          :currentQuestion="currentQuestion || undefined"
        />
      </Card>

      <NextButton
        size="large"
        @click="handleNextQuestion"
        :loading="isLoading"
        data-testid="quizter-next-question-button"
      >
        {{ isNextQuestionFinal ? t('results.final_question_announcement') : t('results.button_next_question') }}
      </NextButton>
    </template>
  </div>
</template>
